import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import staticData from "../../assests/staticData.json";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
// import required modules
import { Autoplay, EffectFade } from "swiper/modules";
import { CCol, CContainer, CRow } from "@coreui/react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowRight } from "@fortawesome/free-solid-svg-icons";

export default function HomeSlider() {
  const { home_banner } = staticData;
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);
  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={true}
        loop={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        speed={2000}
        modules={[Autoplay, EffectFade]}
        className="mySwiper"
      >
        {home_banner.map((banner, index) => (
          <SwiperSlide key={index} className="position-relative">
            <div
              className="home-banner-main-img"
              style={{
                backgroundImage: `url(${
                  isMobile
                    ? require(`../../assests/${banner.banner_mob_image}`)
                    : require(`../../assests/${banner.banner_web_image}`)
                })`,
              }}
            >
              <CContainer>
                <CRow>
                  <CCol lg={8}>
                    <div className="Homebanner-content-wrapper">
                      <div className="Homebanner-content-placeholder">
                        <div className="banner-content-header">
                          <div className="banner-title-wrapper">
                            <h2 className="mb-0">{banner.banner_title}</h2>
                          </div>
                        </div>
                        <div className="banner-content-middle">
                          <div className="banner-cta">
                            <p className="mb-0">{banner.banner_cta}</p>
                          </div>
                        </div>
                        <div className="banner-content-footer mb-lg-5 mb-3">
                          <div className="banner-slogan">
                            <h4>{banner.banner_slogan}</h4>
                          </div>
                          <div className="banner-link">
                            <Link to={"/referrels"}>
                              {banner.banner_btn_title}{" "}
                              <span className="ms-2">
                                <FontAwesomeIcon icon={faLongArrowRight} />
                              </span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CContainer>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
